import React from "react";
import withPreventDoubleClick from "../../utils/withPreventDoubleClick";
import {IconButton} from "react-native-paper";
import {theme} from "@common/theme/theme";


const IconButtonM = ({...props}) => {
    return (
        <IconButton
            containerColor={theme.colors.transparent}
            {...props}
        />
    )
}
export default withPreventDoubleClick(IconButtonM)